import { createApi } from '@reduxjs/toolkit/query/react';
import { ReauthBaseQuery } from '@skynet/data-auth-api';
import { assistantSmmApiBaseQuery } from '@skynet/data-assistant-smm-api';

// Empty API to use as a base for code generation
// Uses the assistant-smm base query with automatic token refresh
export const baseApi = createApi({
  reducerPath: 'smmApi',
  baseQuery: ReauthBaseQuery(assistantSmmApiBaseQuery),
  endpoints: () => ({}),
});
